import PropTypes from 'prop-types';
import React from 'react';
import EditableCheckbox from './editableCheckbox.jsx';
import EditableSelect from './editableSelectField.jsx';

class ToggleSelect extends React.PureComponent {
  static displayName = 'ToggleSelect';

  static propTypes = {
    className: PropTypes.string,
    condition: PropTypes.bool,
    dataKey: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    keys: PropTypes.array,
    onChange: PropTypes.func,
    options: PropTypes.array.isRequired,
    label: PropTypes.string,
    value: PropTypes.string,
  };

  static defaultProps = {
    condition: true,
    disabled: false,
  };

  state = {
    showSelect: false,
  };

  showSelect = (e) => {
    let firstValue = '';

    if (this.props.keys && this.props.keys.length > 0) {
      firstValue = this.props.keys[0];
    } else if (this.props.options && this.props.options.length > 0) {
      firstValue = this.props.options[0];
    }

    let val = parseInt(firstValue);

    val = isNaN(val) || val.toString().length !== firstValue.length ? firstValue : val;

    // Set to first key/option on checking the box incase they don't change the dropdown and clear any preferences on hiding the select
    if (e.value && !this.props.value && firstValue !== this.props.value) {
      this.props.onChange({key: this.props.dataKey, value: val});
    } else if (!e.value && this.props.value) {
      this.props.onChange({key: this.props.dataKey, value: undefined});
    }
    this.setState({
      showSelect: e.value,
    });
  };

  value = () => {
    if (this.refs.select) {
      return this.refs.select.value;
    }
    return undefined;
  };

  render() {
    if (this.props.condition) {
      return <div className='form-group'>
        <EditableCheckbox onChange={this.showSelect} dataKey='showSelect' value={this.state.showSelect}
          editMode={true} label={this.props.label} disabled={this.props.disabled} />
        {this.state.showSelect ?
          <EditableSelect onChange={this.props.onChange} dataKey={this.props.dataKey} disabled={this.props.disabled} editMode={true}
              options={this.props.options} keys={this.props.keys} /> : null}
      </div>;
    }
    return null;
  }
}

export default ToggleSelect;
